import React from 'react'
import { useStore } from 'src/state'
import Page from 'src/components/page'
import Section from 'src/components/section'
import Container from 'src/components/container'
import Picture from 'src/components/picture'
import AspectBox from 'src/components/aspect-box'
import HeroSection from 'src/components/hero-section'
import BoxButton from 'src/components/box-button'
import Link from 'src/components/link'

const MembershipPage = () => {
  const {
    membershipPage: { hero, intro, overview, partners, locations, quote },
  } = useStore()

  return (
    <Page className="page-membership">
      <HeroSection {...hero} />
      <Section className="intro">
        <Container className="body">
          <AspectBox x={720} y={900}>
            <Picture defaultWidth={1000} image={intro.image} fitWidth cover />
          </AspectBox>
          <div className="copy">
            <h3 className="title">{intro.title}</h3>
            <p className="description">{intro.description}</p>
            <Link className="cta" to={intro.ctaUrl}>
              <BoxButton>{intro.ctaText}</BoxButton>
            </Link>
          </div>
        </Container>
      </Section>
      <Section className="overview">
        <Container className="copy">
          <h3 className="title size-big">{overview.title}</h3>
          <p className="description">{overview.description}</p>
        </Container>
        <Container className="rows">
          <div className="row headings">
            <div className="col col1" />
            <div className="col col2">
              <div className="tier-number">
                <div className="eyebrow left" />
                <span>{overview.tier1Number}</span>
                <div className="eyebrow right" />
              </div>
              <h3 className="tier-name">{overview.tier1Name}</h3>
            </div>
            <div className="col col3">
              <div className="tier-number">
                <div className="eyebrow left" />
                <span>{overview.tier2Number}</span>
                <div className="eyebrow right" />
              </div>
              <h3 className="tier-name">{overview.tier2Name}</h3>
            </div>
          </div>
          {overview.rows.map((row) => (
            <div key={row.id} className="row">
              <div className="col col1">
                <div>{row.title}</div>
                <div className="hrule" />
              </div>
              <div className="col col2">
                <div>{row.tier1Text}</div>
                <div className="hrule" />
              </div>
              <div className="col col3">
                <div>{row.tier2Text}</div>
                <div className="hrule" />
              </div>
            </div>
          ))}
          <div className="row ctas">
            <div className="col col1" />
            <div className="col col2">
              <Link className="cta" to={overview.tier1ButtonUrl}>
                <BoxButton>{overview.tier1ButtonText}</BoxButton>
              </Link>
            </div>
            <div className="col col3">
              <Link className="cta" to={overview.tier2ButtonUrl}>
                <BoxButton>{overview.tier2ButtonText}</BoxButton>
              </Link>
            </div>
          </div>
        </Container>
      </Section>
      <Section className="partners">
        <Container>
          <h3 className="title size-big">{partners.title}</h3>
          <p className="description">{partners.description}</p>
        </Container>
      </Section>
      <Section className="locations">
        <Container>
          <h3 className="title size-big">{locations.title}</h3>
          <div className="images">
            <AspectBox className="image-1" x={685} y={500}>
              <Link to={locations.locations1Url}>
                <Picture
                  className="default"
                  defaultWidth={1000}
                  image={locations.locations1Image}
                  fitWidth
                  cover
                />
                <Picture
                  className="hover"
                  defaultWidth={1000}
                  image={locations.locations1Hover}
                  fitWidth
                  cover
                />
                <h3 className="text">{locations.locations1Text}</h3>
              </Link>
            </AspectBox>
            <AspectBox className="image-2" x={685} y={500}>
              <Link to={locations.locations2Url}>
                <Picture
                  className="default"
                  defaultWidth={1000}
                  image={locations.locations2Image}
                  fitWidth
                  cover
                />
                <Picture
                  className="hover"
                  defaultWidth={1000}
                  image={locations.locations2Hover}
                  fitWidth
                  cover
                />
                <h3 className="text">{locations.locations2Text}</h3>
              </Link>
            </AspectBox>
          </div>
          <div className="bottom-link">
            <Link to={locations.bottomLinkUrl}>{locations.bottomLinkText}</Link>
          </div>
        </Container>
      </Section>
      <Section className="quote">
        <Container>
          <div className="content">
            <AspectBox className="image" x={1360} y={700}>
              <Picture defaultWidth={1000} image={quote.image} fitWidth cover />
            </AspectBox>
            <div className="copy">
              <h3 className="quote size-big">{quote.quote}</h3>
              <h3 className="author">{quote.author}</h3>
            </div>
          </div>
        </Container>
      </Section>
    </Page>
  )
}

export default MembershipPage
